// Selected category guidance uses the same purpose vocabulary as model extraction and administration.
import { useTranslation } from 'react-i18next';
import { categoryDefinition } from '../../shared/category-rules';
export function CategoryHint({category}:{category?:{id:string;name:string;name_zh?:string|null}|null}) {
  const {i18n}=useTranslation();
  if(!category)return null;
  const rule=categoryDefinition({...category,name_zh:category.name_zh??null});
  return <p className="mt-1 text-xs leading-relaxed text-muted-foreground" data-testid="category-hint">{i18n.language.startsWith('zh')?rule.description_zh:rule.description}</p>;
}
